import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Edition from "./Edition";
import Spacer from "components/Spacer";
import BuyNowButton from "../BuyNowButton";
import EditionType from "models/EditionType";
import Typography from "@material-ui/core/Typography";
import keyArt from "assets/images/homePage/buyNowSection/specialEditionKeyart.png";
import titleImage from "assets/images/homePage/buyNowSection/specialEditionTitle.png";
import ImageSkeleton from "components/skeletons/ImageSkeleton";
import calculateAspectRatio from "utils/calculateAspectRatio";
import imageSizes from "imageSizes";
import NextGenUpgradeText from "./NextGenUpgradeText";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        title: {
            "& img": {
                width: "65%",
                [theme.breakpoints.down("xs")]: {
                    width: "100%",
                },
            },
        },
    });
});

export default function SpecialEdition() {
    const classes = useStyles();

    const textVariant = "body1";

    return (
        <Edition
            keyArt={
                <ImageSkeleton
                    hideBackground
                    aspectRatio={calculateAspectRatio(
                        imageSizes.homePage.buyNowSection.editionKeyart
                    )}
                    src={keyArt}
                />
            }
            editionTitle={
                <div className={classes.title}>
                    <img src={titleImage} alt="Special Edition Text" />
                </div>
            }
            placement="right"
        >
            <Typography variant={textVariant}>DIRT 5 Standard Edition, plus…</Typography>

            <ul>
                <li>
                    <Typography variant={textVariant}>
                        Access to every Year 1 post-launch addition to DIRT 5
                    </Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>
                        3 exclusive vehicles: Ariel Nomad Tactical, Audi TT Safari, VW Beetle
                        Rallycross
                    </Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>
                        3 exclusive player sponsors with fresh objectives, rewards and liveries
                    </Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Currency and XP boosts</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Energy Content Pack</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Uproar Content Pack</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Super Size Content Pack</Typography>
                </li>
                <li>
                    <Typography variant={textVariant}>Wild Spirits Content Pack</Typography>
                </li>
            </ul>

            <Spacer size={2} />
            <BuyNowButton
                edition={EditionType.SPECIAL}
                dialogText={
                    <>
                        <Typography gutterBottom>
                            The Year 1 Edition is digital only and not available to purchase at
                            retail.
                        </Typography>
                        <NextGenUpgradeText />
                    </>
                }
            >
                Buy Year 1 Edition
            </BuyNowButton>
        </Edition>
    );
}
